<template>
    <div class="branch-box app">
        <div class="header-empty"></div>
        <div class="main-content">
            <breadItem :title1="breadTitle1" :title2="breadTitle2" :link1="breadLink1" :link2="breadLink2"></breadItem>
            <div class="main-ul">
                <div class="tab-content" v-for="(item,index) in dataList" :key="index">
                    <div class="img-left fl">
                        <img v-lazy="item.logo" :alt="item.hospital_name" class="img-branch">
                    </div>
                    <div class="img-right fr">
                        <div class="pt10 title"><span class="fs18 mr20">{{item.hospital_name}}</span><a class="source fs14 color-blue hand-shape" v-if="item.online == 1" :href="curDomain +'/branch/index/'+item.english_shortname+'.html'" :title="item.hospital_name" target="_black">医院官网</a></div>
                        <div class="pt10 describe fs14">
                            {{item.guide}}
                            <div class="text-li phone"> 咨询电话：{{item.tel}}</div>
                            <div class="text-li area">医院地址：{{item.address}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <nav-top></nav-top>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import navTop from '@/components/top'
import breadItem from '@/components/breadItem'
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
    error: require('../../assets/images/branch.png'),
    loading: require('../../assets/images/loding.png'),
    preLoad: 1,
    attempt: 1
})
export default {
    props: {

    },
    data() {
        return {
            dataList:[],
            page: 1,
            pageSize:10,
            alltotal:10,
            breadTitle1:'关于我们',
            breadTitle2:'分院介绍',
            breadLink1:'/aboutUs/0.html',
            breadLink2:'',
            curDomain: window.location.href.split(this.$route.path)[0]
        };
    },
    computed: {

    },
    created() {
        this.getList();
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        // goItemHos(name){
        //     var url=window.location.href.split(this.$route.path)[0]+'/branch/index/'+name+'.html';
        //     window.open(url);
        // },
        getList(){
            this.$axios.post(this.api.about.subHospitals,{},res =>{
                this.dataList=res.data;
            },err =>{

            });
        }
    },
    components: {
        navTop,
        breadItem
    },
};
</script>

<style scoped>
.tab-content{margin-bottom:20px;height:220px;padding:20px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(13,52,130,0.1);border-radius:5px;}
.tab-content:hover{box-shadow:0px 0px 10px 0px rgba(13,52,130,0.4);}
.tab-content .img-left{width:180px;height:180px;margin-right:20px;position: relative;}
.tab-content .img-left .img-branch{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
}
/* .tab-content .img-left .img-branch{
    width:auto;
    height:auto;
    max-width: 100%;
    max-height:100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.tab-content .img-left .img-branch-ie9{
    width:100%\9\0!important;
    height:100%\9\0!important;
    display: block\9\0!important;
} */
.tab-content .img-right{width:960px;}
.tab-content .img-right .title{line-height:25px;}
.tab-content .img-right .describe{color:#666;line-height:24px;}

</style>


// WEBPACK FOOTER //
// src/view/aboutUs/branch.vue